var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"list-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"list-content"},_vm._l((_vm.lemposList),function(s){return _c('collocation',{key:s,staticClass:"collocation",attrs:{"lempos-string":s,"pattern":_vm.pattern,"core-indexes":_vm.coreIndexes,"show-core":false}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }